module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "tips-mask-t",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.onCancel.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "tips-wrapper",
    class: {
      'tips-start': _vm.actionShow, 'tips-end': !_vm.actionShow
    }
  }, [_c('div', {
    staticClass: "tips-font"
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('div', {
    staticClass: "tips-btns"
  }, [_c('a', {
    staticClass: "tips-two-btn tips-marbot red-font",
    on: {
      "click": _vm.onConfrim
    }
  }, [_vm._v(_vm._s(_vm.btns[0]))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'alert'),
      expression: "type !== 'alert'"
    }],
    staticClass: "tips-two-btn",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.btns[1]))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8e385ffc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lib/wind-ui/package/confirmSheet/Confirm-sheet.vue
// module id = 603
// module chunks = 1